import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ArrowUpColor1"
});
const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_1707_17586)"><path opacity="0.5" d="M28.9866 18.9027L36.1141 23.0177L29.783 5.6355L12.3559 9.30093L18.6914 12.9587C18.3016 21.0346 12.0953 27.9045 3.88574 34.3644C3.88574 34.3644 13.1392 31.4366 18.3101 28.1326C22.9544 25.165 28.9866 18.9027 28.9866 18.9027Z" fill="url(#paint0_linear_1707_17586)"></path></g><defs><linearGradient id="paint0_linear_1707_17586" x1="30.1789" y1="5.86414" x2="11.2646" y2="38.6246" gradientUnits="userSpaceOnUse"><stop stop-color="#40CD9C"></stop><stop offset="1" stop-color="#40CD9C" stop-opacity="0"></stop></linearGradient><clipPath id="clip0_1707_17586"><rect width="40" height="40" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var arrowUpColor1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { arrowUpColor1 as default };
